export default __webpack_public_path__ + "static/media/IMG_1703.8af99044.jpg";